import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';
import FlowFieldInput from 'conversie-flow-bundle/assets/js/components/flow/fields/FlowFieldInput';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';

/* Conversion Fields */
import ConversionFieldChoice from '../fields/ConversionFieldChoice';

/* Icons */
import InfoIcon from '~/../symbols/info.svg';

/* Common */
import { Icon } from '~/components/common';

export default function ConversionComponentFinanceCalculator({ component, path, id, ...passProps }) {
    return (
        <>
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
                renderField={(field, props) => {
                    if (field.type === 'choice-radio') {
                        return (
                            <div className={props?.colClassName}>
                                <div className="row gutters-1 gutters-lg-4 align-items-center">
                                    <div className="col-12 col-lg-5 col-xxl-4">
                                        <p className="text--sm mt-lg-n1 mt-xxl-n2">
                                            {field?.label}
                                        </p>
                                    </div>
                                    <ConversionFieldChoice
                                        {...props}
                                        field={{
                                            ...field,
                                            label: null,
                                        }}
                                        colClassName="col-12 col-lg-7 col-xxl-8"
                                        formGroupClassName="form-group--flow-choice-grid"
                                        customControlClassName={`custom-control--expanded custom-control--grow ${field?.config?.class}`}
                                        inputType="radio"
                                    />
                                </div>
                            </div>

                        );
                    }

                    if (field.type === 'money') {
                        return (
                            <div className={props?.colClassName}>
                                <div className="row gutters-1 gutters-lg-4 align-items-center">
                                    <div className="col-12 col-lg-5 col-xxl-4">
                                        <label htmlFor={props.id} className="text--sm mt-lg-n1 mt-xxl-n2">
                                            {field?.label}
                                        </label>
                                        {field?.config?.tooltip && (
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip id={`tooltip-${field.name}`}>
                                                        {field.config.tooltip}
                                                    </Tooltip>
                                                }
                                            >
                                                <TooltipButton
                                                    variant="none"
                                                    className="ml-1 p-0 mt-0"
                                                >
                                                    <Icon
                                                        theme="base"
                                                        size={14}
                                                        url={InfoIcon?.url}
                                                        className={``}
                                                    />
                                                </TooltipButton>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                    <FlowFieldInput
                                        {...props}
                                        field={{
                                            ...field,
                                            label: null,
                                        }}
                                        colClassName="col-12 col-lg-7 col-xxl-8"
                                        inputType="number"
                                    />
                                </div>
                            </div>

                        );
                    }
                }}
            />
        </>
    );
}
